import { createContext } from 'react';
import { emptyFunc } from '@shared/react';
import { PaginationOptions } from '@features/Pagination';
import { ITransactionDesc } from './AssignPositionTableProvider';
import { ILogo } from '@widgets/AccountLevelPositionsTable/lib/PositionsTableProvider/PositionsTableContext';

type DateRange = [string | null, string | null];

export interface IAssignPositionTableContext {
    dateRange: DateRange;
    AssignPositionBody: any[];
    arrayWithLogos: ILogo[];
    paginationOptions: PaginationOptions | null;
    sortFieldName: string;
    desc: ITransactionDesc | null;
    userType: string | null;
    setClientDetailsIdentifier: (symbol: string) => void;
    setCusip: (cusip: string) => void;
    setDateRange: (range: DateRange) => void;
    setUserType: (value: string) => void;
    setSecurityType: (value: any) => void;
    setAccountId: (value: any) => void;
}

export const AssignPositionTableContext = createContext<IAssignPositionTableContext>({
    dateRange: [null, null],
    AssignPositionBody: [],
    paginationOptions: null,
    arrayWithLogos: [],
    sortFieldName: '',
    desc: null,
    userType: '',
    setClientDetailsIdentifier: emptyFunc,
    setSecurityType: emptyFunc,
    setCusip: emptyFunc,
    setDateRange: emptyFunc,
    setUserType: emptyFunc,
    setAccountId: emptyFunc,
});
